import { useEffect } from 'react';
import { useNavigate, useLocation } from 'hooks/use-router/use-router';

import { testableRoutes, routes } from 'utils/constants';
import { useTestable } from 'utils/testable/testable';
import { redirectToErrorPage } from 'utils/helpers';

/**
 * Routing validation
 * !important useRouteValidation is called inside the Page wrapper
 * Here we will listen on any changes to routing paths and
 * perform redirects if the route shouldn't be accessible by the user
 */
export const useRouteValidation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { testableFeaturesEnabled } = useTestable();

  useEffect(() => {
    // Get the pathname from the location
    const pathName = location.pathname;

    const isTestableRoute = Object.keys(testableRoutes).includes(pathName);
    const isAppRoute = Object.keys(routes).includes(pathName);

    let isValidRoute = isAppRoute;

    if (isTestableRoute) {
      isValidRoute = testableFeaturesEnabled();
    }

    if (!isValidRoute) {
      const searchParams = new URLSearchParams(location.search);
      redirectToErrorPage(searchParams, navigate);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
};
